const HeadingSection = () => {
  return (
    <section className="bg-acg-light-blue py-12 text-center px-4">
      <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-2">
        Heating &amp; Air Conditioning Southern Highlands
      </h1>
      <p className="text-lg text-muted-foreground">
        Cool-climate heating and cooling from Mittagong to Goulburn —{" "}
        <a href="/services" className="text-primary hover:underline font-medium">
          Explore our full range of AC services
        </a>
      </p>
    </section>
  );
};

export default HeadingSection;
